// extracted by css-extract-rspack-plugin
export default {"formSection":"FormSection__formSection--MoO_b"};